import { render } from "./MainSearchNoResults.vue?vue&type=template&id=d2fe1fc0&scoped=true"
import script from "./MainSearchNoResults.vue?vue&type=script&lang=js"
export * from "./MainSearchNoResults.vue?vue&type=script&lang=js"

import "./MainSearchNoResults.vue?vue&type=style&index=0&id=d2fe1fc0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2fe1fc0"]])

export default __exports__